import { cx } from '@linaria/core';
import { usePageContext } from '../../context.js';
import { AudioPlayer } from '../atom.audio/_audio-player.full.js';
import { wrapper } from './audio.style.js';
import { media } from './shared.style.js';
import { jsx } from 'react/jsx-runtime';

function AudioMedia(props) {
  const pageContext = usePageContext();
  return /*#__PURE__*/jsx("div", {
    className: cx(media, wrapper),
    "data-page-context": pageContext,
    children: /*#__PURE__*/jsx(AudioPlayer, {
      src: props.node.src,
      autoplay: false
    })
  });
}

export { AudioMedia };
//# sourceMappingURL=audio.js.map
